/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./My.vue?vue&type=template&id=0f0fae78&scoped=true&"
import script from "./My.vue?vue&type=script&lang=js&"
export * from "./My.vue?vue&type=script&lang=js&"
import style0 from "./My.vue?vue&type=style&index=0&id=0f0fae78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0fae78",
  null
  
)

export default component.exports